// import { StrictMode } from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./app";
import { AuthProvider } from "./context/AuthProvider";
import { ViewportProvider } from "./context/ViewportProvider";
import { HelmetProvider } from "react-helmet-async";

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <ViewportProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ViewportProvider>
    </AuthProvider>
  </BrowserRouter>
  // </StrictMode>,
);
